/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./AddForm.css";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { TextField } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Button from "@material-ui/core/Button";
import AuthApi from "../../../Services/Authapi";
import { resolveImageUrl } from "../../../../utils/imageUrl";
import FontAwesomeIconComponent from "../../../Layouts/FontAwesomeIconComponent";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Popover from "@material-ui/core/Popover";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import Box from "@material-ui/core/Box";
import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";
import CheckIcon from "@material-ui/icons/Check";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import ls from "local-storage";
import swal from "sweetalert";
import defaultAvatar from "../../../../Images/person.jpg";
import { createSwalLoaderNode } from "../../../Layouts/swalLoader";
const useStyles = makeStyles((theme) => ({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    width: "100%",
  },
  imageName: {
    color: "var(--hrms-text-strong, #111827)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    display: "block",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  uploadArea: {
    width: '100%',
    minHeight: '215px',
    border: `2px dashed ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'var(--hrms-primary-blue-border, #1864bc)'}`,
    borderRadius: '1rem',
    backgroundColor: theme.palette.type === 'dark' ? '#142635' : '#f8fafc',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    padding: theme.spacing(1),
  },
  fileInput: {
    display: 'none',
  },
}));

const iniuser = {
  firstName: "",
  lastName: "",
  email: "",
  personal_email: "", // Added personal_email
  gender: "",
  dob: "",
  photo: "",
  qualification: "",
  last_organization: "",
  roleName: "",
  uploadedImgName: "",
  user: false,
  user_id: 0,
  salary: "",
  mobileNo: "",
  bankName: "",
  bankAccNo: "",
  doj: "",
  employee_promoted_at: "",
  location: "",
  department: "",
  designation: "",
  password: "",
  allowed_ip: "",
  designation_id: "",
  role: [],
  reporting_person_id: [],
};

const EditForm = (props) => {
  const styles = useStyles();
  const classes = props;
  const [editValues, setEditValues] = useState(iniuser);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [Departmentshow, setDepartmentshow] = useState([]);
  const [Departmentshowd, setDepartmentshow1] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [qualificationsLoaded, setQualificationsLoaded] = useState(false);
  const [roleOptions, setRoleOptions] = React.useState([]);
  const [reporting_person_id, setSelectuser] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [newPhotoFile, setNewPhotoFile] = useState(null);
  const [newPhotoPreview, setNewPhotoPreview] = useState(null);
  const fileInputRef = React.useRef(null);
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState("");
  const [dropdownSearch, setDropdownSearch] = useState({
    qualification: "",
    roleName: "",
    department: "",
    designation: "",
    reporting_person_id: "",
  });
  const [explicitEmptySelections, setExplicitEmptySelections] = useState({
    qualification: false,
    roleName: false,
    department: false,
    designation: false,
    reporting_person_id: false,
  });

  const isValidDepartmentValue = (value) => {
    if (!value) return false;
    return Departmentshowd.some(
      (item) => String(item.department || "").trim() === String(value).trim()
    );
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;

    if (name === "designation") {
      const selectedDesignation = Departmentshow.find(
        (d) => d.designation === value
      );
      setEditValues({
        ...editValues,
        designation: value,
        designation_id: selectedDesignation ? selectedDesignation.id : "",
      });
      return;
    }

    setEditValues({ ...editValues, [name]: value });
  };

  const getUserFullName = (user) => {
    if (!user) return "";
    return [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  };

  const getUserInitials = (user) => {
    const fullName = getUserFullName(user);
    if (!fullName) return "U";
    return fullName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0].toUpperCase())
      .join("");
  };

  const openSearchableDropdown = (field, event) => {
    setActiveDropdown(field);
    setDropdownAnchorEl(event.currentTarget);
    setDropdownSearch((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const closeSearchableDropdown = () => {
    setDropdownAnchorEl(null);
    setActiveDropdown("");
  };

  const updateDropdownValue = (field, value) => {
    setEditValues((prev) => {
      if (field === "designation") {
        const selectedId = Departmentshow.find((dept) => dept.designation === value)?.id || "";
        return {
          ...prev,
          designation: value,
          designation_id: value ? selectedId : "",
        };
      }
      if (field === "reporting_person_id") {
        return {
          ...prev,
          reporting_person_id: value ? [value] : [],
        };
      }
      if (field === "roleName") {
        const isEmployee = String(value || "").toLowerCase() === "employee";
        return {
          ...prev,
          roleName: value,
          employee_promoted_at: (isEmployee && !prev.employee_promoted_at)
            ? new Date().toISOString().split("T")[0]
            : prev.employee_promoted_at,
        };
      }
      return {
        ...prev,
        [field]: value,
      };
    });

    setExplicitEmptySelections((prev) => ({
      ...prev,
      [field]: value === "",
    }));

    if (formErrors[field]) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [field]: "",
      }));
    }

    closeSearchableDropdown();
  };

  const getSelectedDropdownLabel = (field) => {
    if (field === "reporting_person_id") {
      const selectedId = Array.isArray(editValues.reporting_person_id) ? editValues.reporting_person_id[0] : "";
      const selectedUser = filteredUsers.find((user) => String(user.id) === String(selectedId));
      return selectedUser ? getUserFullName(selectedUser) || selectedUser.firstName : "";
    }
    if (field === "department") {
      return isValidDepartmentValue(editValues.department) ? editValues.department : "";
    }
    return editValues[field] || "";
  };

  const getDropdownOptions = (field) => {
    if (field === "qualification") {
      return qualifications.map((item) => ({
        value: item.qualification,
        label: item.qualification,
      }));
    }
    if (field === "roleName") {
      return roleOptions;
    }
    if (field === "department") {
      return Departmentshowd.map((item) => ({
        value: item.department,
        label: item.department,
      }));
    }
    if (field === "designation") {
      return Departmentshow.map((item) => ({
        value: item.designation,
        label: item.designation,
      }));
    }
    return filteredUsers.map((user) => ({
      value: user.id,
      label: getUserFullName(user) || user.firstName,
      photo: user.photo || "",
      initials: getUserInitials(user),
    }));
  };

  const renderSearchableSelect = (field, label, options, errorKey = field) => {
    const searchValue = dropdownSearch[field] || "";
    const shouldShowSearch = field === "reporting_person_id";
    const filteredOptions = options.filter((option) =>
      !shouldShowSearch || (option.label || "").toLowerCase().includes(searchValue.toLowerCase())
    );
    const selectedValue = getSelectedDropdownLabel(field);
    const showAvatar = field === "reporting_person_id";
    const hasError = Boolean(formErrors[errorKey]);

    return (
      <React.Fragment>
        <TextField
          fullWidth
          variant="outlined"
          label={label}
          value={selectedValue || (explicitEmptySelections[field] ? "None" : "")}
          onClick={(event) => openSearchableDropdown(field, event)}
          error={hasError}
          inputProps={{ readOnly: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <ExpandMoreIcon />
              </InputAdornment>
            ),
            style: {
              cursor: "pointer",
            },
          }}
        />
        <Popover
          open={activeDropdown === field}
          anchorEl={dropdownAnchorEl}
          onClose={closeSearchableDropdown}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            className: "user-searchable-popover-paper",
          }}
        >
          <Box p={1.5} className="user-searchable-popover-header">
            <Typography variant="subtitle2" className="user-searchable-popover-title">
              {label}
            </Typography>
            {shouldShowSearch && (
              <TextField
                className="attendance-user-search-field"
                fullWidth
                size="small"
                placeholder="Search..."
                variant="outlined"
                value={searchValue}
                onChange={(e) =>
                  setDropdownSearch((prev) => ({
                    ...prev,
                    [field]: e.target.value,
                  }))
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </Box>
          <Divider />
          <div className="user-searchable-popover-list">
            <MenuItem
              className="attendance-user-option"
              onClick={() => updateDropdownValue(field, "")}
            >
              <ListItemText primary="None" />
              {!selectedValue && <CheckIcon style={{ color: "#16a34a", fontSize: "1.2rem" }} />}
            </MenuItem>
            {filteredOptions.map((option) => {
              const isSelected = String(selectedValue) === String(option.label);
              return (
                <MenuItem
                  key={`${field}-${option.value}`}
                  className="attendance-user-option"
                  onClick={() => updateDropdownValue(field, option.value)}
                >
                  <Box display="flex" alignItems="center" width="100%">
                    {showAvatar && (
                      <Avatar src={resolveImageUrl(option.photo) || ""} className="user-searchable-option-avatar">
                        {option.initials}
                      </Avatar>
                    )}
                    <ListItemText primary={option.label} />
                    {isSelected && <CheckIcon style={{ color: "#16a34a", fontSize: "1.2rem" }} />}
                  </Box>
                </MenuItem>
              );
            })}
            {filteredOptions.length === 0 && (
              <div className="user-searchable-empty-state">No results found</div>
            )}
          </div>
        </Popover>
        {hasError && <span className="error">{formErrors[errorKey]}</span>}
      </React.Fragment>
    );
  };

  const validate = (values) => {
    let errors = {};
    const regex = /^[a-zA-Z]/;
    const emailRegx =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const dobRegx =
      /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;
    const Numeric = /^\d+$/;
    const phone = /^[0-9]{10}$/;

    if (!values.firstName) {
      errors.firstName = "Cannot be blank";
    } else if (!regex.test(values.firstName)) {
      errors.firstName = "Invalid firstName format";
    }

    if (!values.lastName) {
      errors.lastName = "Cannot be blank";
    } else if (!regex.test(values.lastName)) {
      errors.lastName = "Invalid lastName format";
    }

    if (!values.email) {
      errors.email = "Cannot be  blank";
    } else if (!emailRegx.test(values.email)) {
      errors.email = "Invalid email format";
    }

    if (!values.dob) {
      errors.dob = "Cannot be  blank";
    } else if (!dobRegx.test(values.dob)) {
      errors.dob = "Invalid dob format";
    }

    if (values.qualification && !regex.test(values.qualification)) {
      errors.qualification = "Invalid qualification format";
    }

    if (!values.roleName) {
      errors.roleName = "Cannot be blank";
    }

    if (!values.salary) {
      errors.salary = "Cannot be blank";
    } else if (!Numeric.test(values.salary)) {
      errors.salary = "Must Be Numeric";
    }
    if (!values.doj) {
      errors.doj = "Cannot be  blank";
    } else if (!dobRegx.test(values.doj)) {
      errors.doj = "Invalid dob format";
    }
    return errors;
  };


  useEffect(() => {
    getQualificationData();
    Departmentshow1()
    Departmentshow2()
    Selectuser1()
  }, []);
  // Revoke object URL to avoid memory leaks
  useEffect(() => {
    return () => {
      if (newPhotoPreview) {
        URL.revokeObjectURL(newPhotoPreview);
      }
    };
  }, [newPhotoPreview]);



  const getQualificationData = async () => {
    try {
      const response = await AuthApi.getQulification();
      if (response && response.data) {
        setQualifications(response.data);
      }
    } catch (error) {
      console.error('Error fetching qualification data:', error);
    } finally {
      setQualificationsLoaded(true);
    }
  };


  const Departmentshow1 = async () => {
    try {
      const response = await AuthApi.Departmentshow();
      if (response && response.data) {
        setDepartmentshow(response.data);
      }
    } catch (error) {
      console.error('Error fetching department data:', error);
    }
  };


  const Departmentshow2 = async () => {
    try {
      const response = await AuthApi.Departmentshow1();
      if (response && response.data) {
        setDepartmentshow1(response.data);
      }
    } catch (error) {
      console.error('Error fetching qualification data:', error);
    }
  };

  useEffect(() => {
    if (editValues.department && Departmentshowd.length > 0 && !isValidDepartmentValue(editValues.department)) {
      setEditValues((prev) => ({
        ...prev,
        department: "",
      }));
      setExplicitEmptySelections((prev) => ({
        ...prev,
        department: true,
      }));
    }
  }, [Departmentshowd, editValues.department]);



  const getFormData = async () => {
    // Extract the encoded user ID from the URL
    const encodedUserId = props.history.location.pathname.split("/").pop();
    
    // Decode the user ID
    const decodedString = atob(encodedUserId);
    const userId = parseInt(decodedString.split("-")[0], 10);

    let user = await AuthApi.singleUser(userId);

    // Ensure user and user.data are defined
    if (user && user.status === true && user.data) {
      let photo = user.data.photo ? resolveImageUrl(user.data.photo) : null; // null if no photo
      let imageName = photo ? photo.substr(photo.lastIndexOf("/") + 1) : "";
      let user_id = userId;
      let firstName =
        user.status === true &&
          user.data &&
          user.data.firstName &&
          (user.data.firstName !== null || user.data.firstName !== false)
          ? user.data.firstName
          : null;
      let lastName =
        user.status === true && user.data && user.data.lastName
          ? user.data.lastName
          : null;
      let email =
        user.status === true && user.data && user.data.email
          ? user.data.email
          : null;
      let personal_email =
        user.status === true && user.data && user.data.personal_email
          ? user.data.personal_email
          : "";
      let gender =
        user.status === true && user.data && user.data.gender
          ? user.data.gender
          : null;
      let dob =
        user.status === true && user.data && user.data.dob ? user.data.dob : null;
      let qualification =
        user.status === true && user.data && user.data.qualification
          ? user.data.qualification
          : null;
      let last_organization =
        user.status === true && user.data && user.data.last_organization
          ? user.data.last_organization
          : null;
      let userRole =
        user.status === true &&
          user.data &&
          user.data.roles &&
          Object.keys(user.data.roles).length > 0
          ? user.data.roles
          : [];
      let roleName = Object.keys(userRole).length > 0 ? userRole[0].name : null;
      let salary =
        user.status === true && user.data && user.data.salary
          ? user.data.salary
          : null;
      let mobileNo =
        user.status === true && user.data && user.data.mobileNo
          ? user.data.mobileNo
          : null;
      let bankName =
        user.status === true && user.data && user.data.bankName
          ? user.data.bankName
          : null;
      let bankAccNo =
        user.status === true && user.data && user.data.bankAccNo
          ? user.data.bankAccNo
          : null;
      let doj =
        user.status === true && user.data && user.data.doj ? user.data.doj : null;
      let employee_promoted_at =
        user.status === true && user.data && user.data.employee_promoted_at
          ? user.data.employee_promoted_at
          : "";

      let location =
        user.status === true && user.data && user.data.location
          ? user.data.location
          : null;
      let department =
        user.status === true && user.data && user.data.department
          ? user.data.department
          : null;
      let designation =
        user.status === true && user.data && user.data.designation
          ? user.data.designation
          : null;

      let password = editValues.password;
      let uploadedImgName = imageName;
      let reporting_person_id = [];

      if (user.status === true && user.data && user.data.reporting_person_id) {
        try {
          reporting_person_id = JSON.parse(user.data.reporting_person_id);
          if (!Array.isArray(reporting_person_id)) {
            reporting_person_id = [];
          }
        } catch (error) {
          console.error("Error parsing reporting_person_id:", error);
        }
      }

      function formatDate(dob) {
        const parts = dob.split("-");
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }

      try {
        let users = await AuthApi.getData();
        if (users && users.data) {
          const loggedUsers = users.data.filter(
            user => user.user_logged === 1 && user.id !== userId
          );
          setFilteredUsers(loggedUsers);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }

      setEditValues({
        firstName: firstName,
        lastName: lastName,
        email: email,
        personal_email: personal_email,
        gender: gender,
        dob: formatDate(dob),
        photo: photo,
        qualification: qualification,
        last_organization: last_organization,
        roleName: roleName,
        uploadedImgName: uploadedImgName,
        salary: salary,
        mobileNo: mobileNo,
        bankName: bankName,
        bankAccNo: bankAccNo,
        doj: doj,
        employee_promoted_at: employee_promoted_at,
        location: location,
        department: department,
        designation: designation,
        password: password,
        user_id: user_id,
        reporting_person_id: reporting_person_id,
      });
    } else {
      console.error("User data is not available");
    }
  };
  useEffect(() => { setTimeout(() => getFormData(), 1000) }, []);

  const imgUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    // Create local preview; do not upload yet
    const objectUrl = URL.createObjectURL(file);
    setNewPhotoFile(file);
    setNewPhotoPreview(objectUrl);
  };

  const removeImg = async (e) => {
    // If a new image is selected but not uploaded yet, just clear the preview
    if (newPhotoPreview) {
      swal({
        title: "Remove selected image?",
        text: "This will clear the image you just selected.",
        icon: "warning",
        buttons: ["Cancel", "Yes, remove it"],
        dangerMode: true,
      }).then((willDelete) => {
        if (!willDelete) {
          return;
        }
        try {
          URL.revokeObjectURL(newPhotoPreview);
        } catch (err) {}
        setNewPhotoPreview(null);
        setNewPhotoFile(null);
        if (fileInputRef && fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      });
      return;
    }

    swal({
      title: "Remove profile picture?",
      text: "This will delete the current profile picture.",
      icon: "warning",
      buttons: ["Cancel", "Yes, remove it"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) {
        return;
      }

      // If there's no custom photo, just reset state
      if (!editValues.photo) {
        setEditValues({
          ...editValues,
          photo: null,
          uploadedImgName: "",
        });
        return;
      }

      try {
        let imageLink = editValues.photo;
        if (imageLink && imageLink.indexOf("/", 7) !== -1) {
          imageLink = imageLink.substr(imageLink.indexOf("/", 7) + 1);
        }
        let remImg = await AuthApi.deleteImg(imageLink);
        if (remImg && remImg.status === true) {
          setEditValues({
            ...editValues,
            photo: null,
            uploadedImgName: "",
          });
          if (fileInputRef && fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        } else {
          swal("Error", "Failed to remove image.", "error");
        }
      } catch (error) {
        console.error(error);
        swal("Error", "Failed to remove image.", "error");
      }
    });
  };

  async function RoleData() {
    let role = await AuthApi.getRole();
    if (role && role.status === true) {
      if (Object.keys(role.data).length > 0) {
        const mappedRoles = Object.keys(role.data).map((key) => ({
          value: role.data[key].name,
          label: role.data[key].name,
        }));
        setRoleOptions(mappedRoles);
      } else {
        setRoleOptions([]);
      }
    }
  }
  React.useEffect(() => { RoleData() }, []);

  //    const  addRole =(e) =>{
  //         let user = editValues;
  //         console.log(user);
  //         user.roleName = e.target.value;
  //         setEditValues({
  //             editValues: user
  //         })
  //     }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors(validate(editValues));
    setIsSubmitting(true);
    if (Object.keys(formErrors).length === 0) {
      await editUser1();
    }
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmitting) {
      // submitForm();
      editUser1();
    }
  }, [formErrors]);


  const editUser1 = async () => {
    const payload = {
      ...editValues,
      allowed_ip: editValues.allowed_ip,
      reporting_person_id: editValues.reporting_person_id,
    };
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode(),
    });
    try {
      // If a new image was selected (but not uploaded yet), upload it first
      if (newPhotoFile) {
        const postData = new FormData();
        postData.append("file", newPhotoFile);
        const updateImg = await AuthApi.updateImg(postData);
        if (updateImg && updateImg.status === true) {
          payload.photo = resolveImageUrl(updateImg.data.image_url);
          payload.uploadedImgName = updateImg.data.image_name;
        }
      }
      let status = await AuthApi.updateUser(payload, editValues.user_id);
      swal.close();
      if (status && status.status === true) {
        // Clear pending state after successful save
        setNewPhotoFile(null);
        setNewPhotoPreview(null);
        if (fileInputRef && fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        swal("Success", "User updated successfully", "success").then(() => {
          props.history.push("/users");
        });
      }
    } catch (error) {
      swal.close();
      console.error("Error updating editusers:", error);
      swal("Error", "Failed to update user. Please try again later.", "error");
    }
  };

  const Selectuser1 = async () => {
    const encodedUserId = props.history.location.pathname.split("/").pop();
    const decodedString = atob(encodedUserId);
    const userId = parseInt(decodedString.split("-")[0], 10);
    try {
      let users = await AuthApi.getData();
      if (users && users.data) {
        const loggedUsers = users.data.filter(
          user => user.user_logged === 1 && user.id !== userId
        );
        setSelectuser(loggedUsers);
        setFilteredUsers(loggedUsers);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  return (
    <div>
      <form className={`${classes.root} common-form-fields`} onSubmit={handleSubmit}>
        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              name="firstName"
              label="First Name"
              variant="outlined"
              error={formErrors.firstName && true}
              value={
                editValues && editValues.firstName !== null
                  ? editValues.firstName
                  : null
              }
              // focused={(editValues && editValues.firstName !== null) ? true : false}
              onChange={handleChange1}
              className={formErrors.firstName && "input-error"}
            />
            {formErrors.firstName && (
              <span className="error">{formErrors.firstName}</span>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              name="lastName"
              label="Last Name"
              variant="outlined"
              value={
                editValues && editValues.lastName !== null
                  ? editValues.lastName
                  : null
              }
              // focused={(editValues && editValues.lastName !== null) ? true : false}
              onChange={handleChange1}
              className={formErrors.lastName && "input-error"}
              error={formErrors.lastName && true}
            />
            {formErrors.lastName && (
              <span className="error">{formErrors.lastName}</span>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              name="email"
              label="Email-address"
              variant="outlined"
              value={
                editValues && editValues.email !== null
                  ? editValues.email
                  : null
              }
              // focused={(editValues && editValues.email !== null) ? true : false}
              error={formErrors.email && true}
              onChange={handleChange1}
              className={formErrors.email && "input-error"}
            />
            {formErrors.email && (
              <span className="error">{formErrors.email}</span>
            )}
          </Grid>
          {/* Personal Email Field */}
       
        </Grid>
        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={4} style={{ display: "flex" }}>
            <FormControl component="fieldset">
              <Grid container className={classes.root} spacing={4}>
                <Grid item xs={12} style={{ display: "flex" }}>
                  <FormLabel component="legend">Gender</FormLabel>
                </Grid>
              </Grid>
              <RadioGroup
                aria-label="gender"
                name="gender"
                onChange={handleChange1}
                value={editValues.gender}
              // focused={(editValues && editValues.gender !== null) ? true : false}
              >
                <Grid container className={classes.root} spacing={2}>
                  <Grid item xs={6}>
                    <FormControlLabel
                      value="Female"
                      control={<Radio />}
                      label="Female"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      value="Male"
                      control={<Radio />}
                      label="Male"
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="date"
              label="Birthday"
              name="dob"
              type="date"
              variant="outlined"
              // defaultValue="2017-05-24"
              error={formErrors.dob && true}
              value={
                editValues && editValues.dob !== null ? editValues.dob : null
              }
              // focused={(editValues && editValues.dob !== null) ? true : false}
              onChange={handleChange1}
              className={`${classes.textField || ""} ${
                formErrors.dob ? "input-error" : ""
              }`}
              InputLabelProps={{
                shrink: true,
              }}
            />
            {formErrors.dob && <span className="error">{formErrors.dob}</span>}
          </Grid>

          <Grid item xs={4}>
            <TextField
              fullWidth
              id="date"
              label="Date of joining"
              name="doj"
              type="date"
              variant="outlined"
              // defaultValue="2017-05-24"
              error={formErrors.doj && true}
              value={
                editValues && editValues.doj !== null
                  ? editValues.doj
                  : null
              }
              // focused={(editValues && editValues.dob !== null) ? true : false}
              onChange={handleChange1}
              className={`${classes.textField || ""} ${
                formErrors.doj ? "input-error" : ""
              }`}
              InputLabelProps={{
                shrink: true,
              }}
            />
            {formErrors.doj && (
              <span className="error">{formErrors.doj}</span>
            )}
          </Grid>
        </Grid>
        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={4}>
            {renderSearchableSelect(
              "qualification",
              "Qualification",
              getDropdownOptions("qualification")
            )}
          </Grid>

          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              name="salary"
              label="Salary"
              variant="outlined"
              value={
                editValues && editValues.salary !== null
                  ? editValues.salary
                  : null
              }
              // focused={(editValues && editValues.lastName !== null) ? true : false}
              onChange={handleChange1}
              className={formErrors.salary && "input-error"}
              error={formErrors.salary && true}
            />
            {formErrors.salary && (
              <span className="error">{formErrors.salary}</span>
            )}
          </Grid>
          <Grid item xs={4}>
            {renderSearchableSelect(
              "roleName",
              "Role",
              getDropdownOptions("roleName")
            )}
          </Grid>
        </Grid>

        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              name="password"
              type="password"
              label="Password"
              variant="outlined"
              error={formErrors.password && true}
              value={editValues.password}
              onChange={handleChange1}
              className={formErrors.password && "input-error"}
            />
            {formErrors.password && (
              <span className="error">{formErrors.password}</span>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="personal_email"
              name="personal_email"
              label="Personal Email"
              variant="outlined"
              value={editValues.personal_email}
              onChange={handleChange1}
            />
          </Grid>
          {String(editValues.roleName || "").toLowerCase() === "employee" && (
            <Grid item xs={4}>
              <TextField
                fullWidth
                id="employee_promoted_at"
                label="Employee Promotion Date"
                name="employee_promoted_at"
                type="date"
                variant="outlined"
                value={editValues.employee_promoted_at || ""}
                onChange={handleChange1}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          )}
        </Grid>

        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={12}>
            <div className={styles.root}>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{ color: "var(--hrms-primary-blue-end, #036dda)" }}
                >
                  <Typography className={`${styles.heading} common-form-page-title`}>
                    Other Settings
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container className={classes.root} spacing={5}>
                    <Grid item xs={12} md={8}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="location"
                            label="Location"
                            variant="outlined"
                            value={
                              editValues && editValues.location !== null
                                ? editValues.location
                                : null
                            }
                            onChange={handleChange1}
                            className={formErrors.location && "input-error"}
                            error={formErrors.location && true}
                          />
                          {formErrors.location && (
                            <span className="error">{formErrors.location}</span>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="mobileNo"
                            label="Contact Number"
                            variant="outlined"
                            value={
                              editValues && editValues.mobileNo !== null
                                ? editValues.mobileNo
                                : null
                            }
                            onChange={handleChange1}
                            className={formErrors.mobileNo && "input-error"}
                            error={formErrors.mobileNo && true}
                          />
                          {formErrors.mobileNo && (
                            <span className="error">{formErrors.mobileNo}</span>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="bankAccNo"
                            label="Bank Account Number"
                            variant="outlined"
                            value={
                              editValues && editValues.bankAccNo !== null
                                ? editValues.bankAccNo
                                : null
                            }
                            onChange={handleChange1}
                            className={formErrors.bankAccNo && "input-error"}
                            error={formErrors.bankAccNo && true}
                          />
                          {formErrors.bankAccNo && (
                            <span className="error">{formErrors.bankAccNo}</span>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="bankName"
                            label="Bank Name"
                            variant="outlined"
                            value={
                              editValues && editValues.bankName !== null
                                ? editValues.bankName
                                : null
                            }
                            onChange={handleChange1}
                            className={formErrors.bankName && "input-error"}
                            error={formErrors.bankName && true}
                          />
                          {formErrors.bankName && (
                            <span className="error">{formErrors.bankName}</span>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {renderSearchableSelect(
                            "designation",
                            "Designation",
                            getDropdownOptions("designation")
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {renderSearchableSelect(
                            "reporting_person_id",
                            "Select User",
                            getDropdownOptions("reporting_person_id")
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {renderSearchableSelect(
                            "department",
                            "Department",
                            getDropdownOptions("department")
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="last_organization"
                            label="Last Organization"
                            variant="outlined"
                            value={
                              editValues && editValues.last_organization !== null
                                ? editValues.last_organization
                                : null
                            }
                            error={formErrors.last_organization && true}
                            onChange={handleChange1}
                            className={formErrors.last_organization && "input-error"}
                          />
                          {formErrors.last_organization && (
                            <span className="error">{formErrors.last_organization}</span>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <div
                        className={styles.uploadArea}
                        onClick={() => fileInputRef.current && fileInputRef.current.click()}
                      >
                        <input
                          accept="image/*"
                          className={styles.fileInput}
                          name="photo"
                          id="contained-button-file"
                          type="file"
                          ref={fileInputRef}
                          onChange={(e) => imgUpload(e)}
                        />
                        <Avatar
                          src={newPhotoPreview || resolveImageUrl(editValues.photo) || defaultAvatar}
                          alt="User profile image"
                          className="user-form-upload-avatar"
                        />
                        <Typography variant="subtitle2" style={{ color: 'var(--hrms-primary-blue-end, #036dda)', fontWeight: 'bold', marginBottom: '2px' }}>
                          Drag & Drop your file here
                        </Typography>
                        <Typography variant="caption" style={{ color: 'var(--hrms-primary-blue-end, #036dda)', marginBottom: '4px' }}>
                          or
                        </Typography>
                        <Button
                          variant="outlined"
                          color="primary"
                          component="span"
                          size="small"
                          startIcon={<CloudUploadIcon />}
                          style={{
                            textTransform: 'none',
                            fontWeight: 'bold',
                            padding: '2px 10px',
                            fontSize: '0.8rem',
                            color: 'var(--hrms-primary-blue-end, #036dda)',
                            borderColor: 'var(--hrms-primary-blue-border, #1864bc)'
                          }}
                        >
                          Upload a file
                        </Button>
                      </div>
                      {(newPhotoPreview || editValues.photo) && (
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                          <Typography
                            variant="subtitle1"
                            gutterBottom
                            className={styles.imageName}
                            title={newPhotoFile ? newPhotoFile.name : editValues.uploadedImgName}
                          >
                            {newPhotoFile ? newPhotoFile.name : editValues.uploadedImgName}
                          </Typography>
                          <Button onClick={(e) => removeImg(e)} size="small" color="secondary">
                            Remove Image
                          </Button>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          </Grid>
        </Grid>

        <div className="holiday-form-actions">
            <Button type="submit" variant="contained" color="primary" className="holiday-btn-submit" style={{ textTransform: "none" }}>
              Edit
            </Button>
            <Button
              type="button"
              className="holiday-btn-cancel"
              style={{ textTransform: "none" }}
              onClick={(e) => {
                e.preventDefault();
                props.history.push("/users");
              }}
            >
              Cancel
            </Button>
        </div>
      </form>
    </div>
  );
};

export default EditForm;
